import Text from "@components/common/Text";
import Title from "@components/common/Title";
import Layout from "@components/layouts/Layout";
import { Link } from "gatsby";
import React from "react";
import HeroSection from "../../components/newVersion/HeroSection";
import rankings from "../../data/Rankings";

const filteredRankings = rankings.filter((item) => item.enabled);

const Component = () => {
    return (
        <>
            <Layout
                seo={{
                    title: "¡Los mejores de iOpos!",
                    description:
                        "Nuestros jugadores compiten cada día por demostrar quién es el mejor. Aquí puedes ver los rankings de los usuarios que han completado más tests, obtenido las mejores puntuaciones y dominado nuestras pruebas. Cada semana actualizamos las posiciones, ¡y el primer lugar está esperando por ti!",
                    image: "/images/bgs/bgRank4.jpg",
                }}
                mode="fixed"
            >
                <HeroSection
                    filename="bgs/bgRank4"
                    firstTitle="¡Los mejores de iOpos!"
                    secondTitle="Rankings de tests y puntuaciones"
                    thirdTitle="Descubre quién ha completado más tests, quién consigue las mejores notas y quién destaca por su regularidad en las pruebas. Actualizamos las posiciones cada semana para que veas la evolución real… y el primer puesto puede ser tuyo si mantienes **ritmo, precisión y constancia**."
                    showScrollDownIcon={true}
                />

                <div className="container pt-20">
                    <Title>¿Quiénes son los mejores de iOpos Academia?</Title>
                    <Text>
                        Nuestros jugadores compiten cada día por demostrar quién
                        es el mejor. Aquí puedes ver los rankings de los
                        usuarios que han completado más tests, obtenido las
                        mejores puntuaciones y dominado nuestras pruebas. Cada
                        semana actualizamos las posiciones, ¡y el primer lugar
                        está esperando por ti!
                    </Text>
                </div>

                <div className="container pb-20 pt-10 lg:px-0">
                    <div className="grid grid-cols-1 gap-10 md:grid-cols-2">
                        {filteredRankings?.map((item) => (
                            <RenderRanking key={item.id} item={item} />
                        ))}
                    </div>
                </div>
            </Layout>
        </>
    );
};

const RenderRanking = ({ item }) => {
    return (
        <Link
            href={item.link}
            className="aspect-h-3 aspect-w-4 relative flex h-32 overflow-hidden rounded-md bg-gray-200 shadow-lg"
        >
            {item.image && (
                <img
                    src={item.image}
                    className="absolute z-0 h-full w-full object-cover"
                    alt={item.title}
                />
            )}

            {item.image && (
                <div className="absolute">
                    <img
                        src="/images/rankings/barres.png"
                        className="absolute bottom-0 right-0 z-0 h-24 w-24 object-cover md:h-32 md:w-32"
                        alt={item.title}
                    />
                </div>
            )}

            <div className="absolute z-20">
                <h1 className="absolute bottom-0 w-full bg-ccyan bg-opacity-50 px-5 py-3 font-semibold text-white">
                    {item.title}
                </h1>
            </div>
        </Link>
    );
};

export default Component;
